<template>
  <div class="project">
    <button class="back-btn" @click="$router.push('/profil')">
      &#60; Tilbake til profil
    </button>

    <h1>Mine prosjekter</h1>

    <div class="project-item required">
      <label>Navn på prosjekt</label>
      <input type="text" placeholder="Navn" v-model="project.title" required />
      <label>URL</label>
      <input type="text" placeholder="Lenke" v-model="project.link" required />
    </div>

    <textarea
      placeholder="Beskrivelse"
      v-model="project.description"
    ></textarea>

    <button class="primary" @click="save">Lagre</button>
    <button
      v-if="project.projectId"
      class="secondary danger"
      @click="deleteProject(project.projectId)"
    >
      Slett prosjektet
    </button>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";

export default {
  name: "ProjectsEdit",
  data() {
    return {
      project: {},
    };
  },
  async mounted() {
    if (Object.keys(this.userInfo).length === 0) {
      await this.getUserInfo();
    }

    if (this.$route.params.id != undefined) {
      this.project = await this.getUserPortfolioProject(this.$route.params.id);
    }
  },
  computed: {
    ...mapState(["userInfo"]),
  },
  methods: {
    ...mapActions([
      "getUserInfo",
      "getUserPortfolioProject",
      "addUserPortfolioProject",
      "updateUserPortfolioProject",
      "deleteUserPortfolioProject",
    ]),

    async save() {
      let link = this.project.link;
      if (!link.startsWith("http://") && !link.startsWith("https://")) {
        link = `http://${link}`;
      }

      /*
       * If you create a project, the projectId should be null,
       * backend will create one.
       * Otherwise use existing projectId to patch.
       */
      let project = {
        userId: this.userInfo.id,
        projectId: this.project.projectId,
        title: this.project.title,
        link: link,
        // link: "http://" + this.project.link,
        description: this.project.description,
      };

      if (this.$route.params.id != undefined) {
        await this.updateUserPortfolioProject(project)
          .then(() => {
            this.$router.push("/profil");
          })
          .catch((error) => {
            console.log("Kunne ikke oppdatere prosjektet: ", error);
          });
      } else {
        await this.addUserPortfolioProject(project)
          .then(() => {
            this.$router.push({ name: "Profile" });
          })
          .catch((error) => {
            console.log("Kunne ikke lage prosjekt: ", error);
          });
      }
    },

    async deleteProject(projectId) {
      await this.deleteUserPortfolioProject(projectId)
        .then(() => {
          this.$router.push({ name: "Profile" });
        })
        .catch((error) => {
          console.log("Kunne ikke slette prosjekt: ", error);
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.project {
  margin: auto;
}

input {
  display: block;
  margin: 10px 0;
  padding: 15px;
}

button {
  display: flex;
  flex-direction: column;
  margin-top: 15px;
}

.back-btn {
  background-color: var(--secondary-color);
}

.required label::after {
  content: "*";
  color: var(--primary-color);
}

textarea {
  resize: vertical;
  padding: 15px;
  border-radius: 5px;
  border: 1px solid var(--primary-border-color);
  height: 150px;
  color: #333333;
  font-size: 18px;
}

.project-item {
  margin: 2em 0;

  & > input,
  & > textarea {
    margin: 0.5em 0;
  }

  & > input {
    display: block;
  }
}
</style>